<template>
  <div id="app" class="app">
    <layout/>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout'
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue'

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      Layout
    }
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue